import React, { Component } from 'react'
import BigCalendar from 'react-big-calendar'
import moment from 'moment'
import classnames from 'classnames'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import CustomEventModal from 'components/Modals/CustomEventModal'
import store from 'services/store'
import { getAddingOrEditingCustomEvent } from 'app/selectors/customEvent'
import { CustomEventActionCreators } from 'app/reducers/CustomEventRedux'
import Info from 'components/Calendar/Info'
import { Button } from 'controls'
import {
  views,
  defaultView,
  startAccessor,
  endAccessor,
  minTime,
  maxTime,
  messages,
  formats,
  components
} from './calendarConfig'

import styles, {
  overwrites,
  container,
  containerHeader,
  responsiveContainer
} from './styles'

BigCalendar.momentLocalizer(moment) // or globalizeLocalizer

class Calendar extends Component {
  constructor(props) {
    super(props)
    const { startDate } = this.props.query || {}
    const parsedDate =
      (startDate && moment(startDate, 'YYYY-MM-DD').toDate()) || new Date()
    const view = 'week'
    const interval = this.getInterval(view, parsedDate)
    this.state = {
      selectedEvent: null,
      events: [],
      date: parsedDate,
      view: 'week',
      ...interval
    }
    this.props.actions.eventsRequest(
      interval.startDate.valueOf(),
      interval.endDate.valueOf()
    )
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      eventsRequestData: {
        finished: finishedEvents,
        error: errorEvents,
        response: responseEvents
      },
      eventDetailsRequestData: {
        finished: finishedEvent,
        error: errorEvent,
        response: responseEvent
      },
      eventCreateRequestData: {
        finished: finishedCreateEvent,
        error: errorCreateEvent,
        response: responseCreateEvent
      }
    } = nextProps

    const events =
      this.props.eventsRequestData.loading && finishedEvents && !errorEvents
        ? {
          events: responseEvents.map(e => ({
            ...e,
            startDate: new Date(e.start),
            endDate: new Date(e.end)
          }))
        }
        : {}

    const selectedEvent =
      this.props.eventDetailsRequestData.loading && finishedEvent && !errorEvent
        ? { selectedEvent: responseEvent }
        : {}
    this.setState({
      ...events,
      ...selectedEvent
    })

    if (
      this.props.eventCreateRequestData.loading &&
      finishedCreateEvent &&
      !errorCreateEvent
    ) {
      this.props.actions.eventsRequest(
        this.state.startDate.valueOf(),
        this.state.endDate.valueOf()
      )
    }
  }

  closeModal = () => this.setState({ addingEvent: false })

  selectEvent = ({ id }) => {
    this.props.actions.eventDetailsRequest(id)
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  }

  deselectEvent = () => this.setState({ selectedEvent: null })

  datedChanged = date => {
    const interval = this.getInterval(this.state.view, date)
    this.setState({ date, ...interval }, () =>
      this.props.actions.eventsRequest(
        interval.startDate.valueOf(),
        interval.endDate.valueOf()
      )
    )
  }

  viewChanged = view => {
    const interval = this.getInterval(view, this.state.date)
    this.setState({ view, ...interval }, () =>
      this.props.actions.eventsRequest(
        interval.startDate.valueOf(),
        interval.endDate.valueOf()
      )
    )
  }

  eventModified = id => {
    this.props.actions.eventsRequest(
      this.state.startDate.valueOf(),
      this.state.endDate.valueOf()
    )
    this.props.actions.eventDetailsRequest(id)
  }

  eventRemoved = () => {
    this.props.actions.eventsRequest(
      this.state.startDate.valueOf(),
      this.state.endDate.valueOf()
    )
    this.setState({ selectedEvent: null })
  }

  getInterval = (view, date) => {
    switch (view) {
      case 'week':
        return {
          startDate: moment(date).startOf('isoWeek'),
          endDate: moment(date).endOf('isoWeek')
        }
        break
      case 'day':
        return {
          startDate: moment(date).startOf('day'),
          endDate: moment(date).endOf('day')
        }
        break
      default:
        // month
        return {
          startDate: moment(date).startOf('month'),
          endDate: moment(date).endOf('month')
        }
        break
    }
  }

  openEventModal = slotInfo => {
    this.props.actions.setSlotInfo(slotInfo)
    this.props.actions.setEventType('CUSTOM_EVENT')
    this.props.actions.setAddingOrEditingCustomEvent(true)
  }

  render() {
    const { events, selectedEvent } = this.state
    const {
      addingOrEditingCustomEvent,
      eventDetailsRequestData: { loading }
    } = this.props

    return (
      <div className="container">
        <div
          className={classnames('calendar', {
            'responsive-calendar': selectedEvent
          })}
        >
          <div className="header">
            <p>Mis Actividades</p>
            <Button color="secondary"
              outline onClick={() => this.openEventModal({ start: moment.now(), end: moment.now() })}>Crear Actividad</Button>
          </div>

          <BigCalendar
            selectable
            views={views}
            defaultDate={this.state.date}
            defaultView={defaultView}
            events={events}
            components={components}
            messages={messages}
            formats={formats}
            onNavigate={this.datedChanged}
            onView={this.viewChanged}
            min={minTime}
            max={maxTime}
            startAccessor={startAccessor}
            endAccessor={endAccessor}
            onSelectEvent={this.selectEvent}
            onSelectSlot={slotInfo => this.openEventModal(slotInfo)}
          />
        </div>
        <Info
          loading={loading}
          event={selectedEvent}
          onClose={this.deselectEvent}
          onEventModified={this.eventModified}
          onEventRemove={this.eventRemoved}
        />
        {addingOrEditingCustomEvent && <CustomEventModal />}
        <style jsx global>
          {styles}
        </style>
        <style jsx>{container}</style>
        <style jsx>{overwrites}</style>
        <style jsx>{responsiveContainer}</style>
        <style jsx>{containerHeader}</style>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  eventsRequestData: store.between('appointment').selector(state),
  eventDetailsRequestData: store.find('appointment').selector(state),
  eventCreateRequestData: store.create('appointment').selector(state),
  addingOrEditingCustomEvent: getAddingOrEditingCustomEvent(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      eventsRequest: store.between('appointment').action,
      eventDetailsRequest: store.find('appointment').action,
      setAddingOrEditingCustomEvent:
        CustomEventActionCreators.setAddingOrEditingCustomEvent,
      setEventType: CustomEventActionCreators.setEventType,
      setSlotInfo: CustomEventActionCreators.setSlotInfo
    },
    dispatch
  )
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Calendar)
